"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var CircularProgress_1 = require("@material-ui/core/CircularProgress");
var FormControl_1 = require("@material-ui/core/FormControl");
var FormHelperText_1 = require("@material-ui/core/FormHelperText");
var InputAdornment_1 = require("@material-ui/core/InputAdornment");
var InputLabel_1 = require("@material-ui/core/InputLabel");
var MenuItem_1 = require("@material-ui/core/MenuItem/MenuItem");
var Select_1 = require("@material-ui/core/Select");
var FieldCoreBase_1 = require("@react-form-fields/core/components/FieldCoreBase");
var ValidationContextRegister_1 = require("@react-form-fields/core/components/ValidationContextRegister");
var React = require("react");
var config_1 = require("../config");
var FieldSelect = /** @class */ (function (_super) {
    tslib_1.__extends(FieldSelect, _super);
    function FieldSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (event) {
            var value = event.target ? event.target.value : event;
            config_1.getConfig().validationOn === 'onChange' && _this.setState({ showError: true });
            _this.props.onChange(value === '' ? null : value);
        };
        _this.onBlur = function (e) {
            _this.props.onBlur && _this.props.onBlur(e);
            config_1.getConfig().validationOn === 'onBlur' && _this.setState({ showError: true });
        };
        return _this;
    }
    FieldSelect.prototype.render = function () {
        var _a = this.props, value = _a.value, options = _a.options, children = _a.children, label = _a.label, loading = _a.loading, helperText = _a.helperText, emptyOption = _a.emptyOption, extra = tslib_1.__rest(_a, ["value", "options", "children", "label", "loading", "helperText", "emptyOption"]);
        return (React.createElement(React.Fragment, null,
            React.createElement(ValidationContextRegister_1.default, { field: this }),
            React.createElement(FormControl_1.default, { margin: extra.margin || 'normal', fullWidth: true, error: !!this.errorMessage, variant: extra.variant },
                !!label &&
                    React.createElement(InputLabel_1.default, { required: this.isRequired, shrink: !!emptyOption || !!value, error: !!this.errorMessage, variant: extra.variant }, label),
                React.createElement(Select_1.default, tslib_1.__assign({}, tslib_1.__assign({ fullWidth: true, endAdornment: !loading ? null : (React.createElement(InputAdornment_1.default, { position: 'end' },
                        React.createElement(CircularProgress_1.default, { size: 20 }))) }, extra, { displayEmpty: !!emptyOption, value: !value && value !== 0 ? '' : value, required: this.isRequired, error: !!this.errorMessage, onChange: this.onChange, onBlur: this.onBlur, submitted: null, touched: null, loading: null })),
                    emptyOption &&
                        React.createElement(MenuItem_1.default, { value: '' }, emptyOption),
                    (options || []).map(function (option) { return (React.createElement(MenuItem_1.default, { disabled: option.disabled, key: option.value, value: option.value }, option.label)); }),
                    children),
                !!(this.errorMessage || helperText) &&
                    React.createElement(FormHelperText_1.default, { error: !!this.errorMessage, variant: extra.variant }, this.errorMessage || helperText))));
    };
    return FieldSelect;
}(FieldCoreBase_1.default));
exports.default = FieldSelect;
//# sourceMappingURL=Select.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-form-fields/material-ui/components/Select.js
// module id = 267
// module chunks = 58